import React from "react";
import { findArray } from 'helpers/utils'
import {
  isFinishedStatus
} from "helpers/status";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck
} from "@fortawesome/free-solid-svg-icons";
import Label from "components/general/Label";
import Flag from "components/presentation/Flag";
import { faStop } from "@fortawesome/free-solid-svg-icons";
import { useViewport } from 'components/general/useViewPort';

const KikScoreboard = ({ data, status }) => {
  const { breakPoint } = useViewport()

  let scoreboard
  let resultStatus = status
  
  let home = data?.results?.home;
  let homeNoc = home?.participant?.organisation?.code;
  let homeResult = home?.resultData;
  let homeWinner = home ? home?.resultWLT : ''
  let homeColourTeam = home?.eventUnitEntries ? findArray(home?.eventUnitEntries, { eue_code: ['COLOUR'] }).eue_value : 'red'
  const homeCardBig = <FontAwesomeIcon color={homeColourTeam} icon={faStop} size="4x" />
  const homeCardSmall = <FontAwesomeIcon color={homeColourTeam} icon={faStop} size="2x" />

  let away = data?.results?.away;
  let awayNoc = away?.participant?.organisation?.code;
  let awayResult = away?.resultData;
  let awayWinner = away ? away?.resultWLT : ''
  let awayColourTeam = away?.eventUnitEntries ? findArray(away?.eventUnitEntries, { eue_code: ['COLOUR'] }).eue_value : 'blue'
  const awayCardBig = <FontAwesomeIcon color={awayColourTeam} icon={faStop} size="4x" />
  const awayCardSmall = <FontAwesomeIcon color={awayColourTeam} icon={faStop} size="2x" />

  let round = findArray(data?.results?.extendedInfos, { ei_code: ['ROUND'] }).ei_value
  let timer = findArray(data?.results?.extendedInfos, { ei_code: ['TIME'] }).ei_value

  let officialHomeCheck
  let officialAwayCheck
  let officialHomeW
  let officialAwayW
  let officialCodeHome
  let officialCodeAway
  let losers

  if (isFinishedStatus(resultStatus)) {
    if (homeWinner?.trim() === 'W') {
      officialCodeHome = home?.resultType
      officialHomeCheck = <FontAwesomeIcon icon={faCheck} />
      officialHomeW = findArray(data?.results?.extendedInfos, { ei_code: ['RES_CODE'] }).ei_value
    }
    if (awayWinner?.trim() === 'W') {
      officialCodeAway = away?.resultType
      officialAwayCheck = <FontAwesomeIcon icon={faCheck} />
      officialAwayW = findArray(data?.results?.extendedInfos, { ei_code: ['RES_CODE'] }).ei_value
    }
    if (homeWinner?.trim() === 'L' && awayWinner?.trim() === 'L') {
      losers = findArray(data?.results?.extendedInfos, { ei_code: ['RES_CODE'] }).ei_value
      officialHomeW = findArray(data?.results?.extendedInfos, { ei_code: ['RES_CODE'] }).ei_value
      officialAwayW = findArray(data?.results?.extendedInfos, { ei_code: ['RES_CODE'] }).ei_value
    }
  }

  scoreboard = (
    <>
      <table className="table">
        <thead>
          <tr>
            {breakPoint === "sm" || breakPoint === "xs"
              ? 
              <>
                <th scope="col" className="text-start">
                  <Label data='HeaderCorner' />
                </th>
                <th scope="col" className="text-center">
                  <Label data='HeaderName' />
                </th>
                <th scope="col" className="text-center">
                  <Label data='HeaderWinner' />
                </th>
                <th scope="col" className="text-center">
                  <Label data='HeaderResult' />
                </th>
                <th scope="col" className="text-center">
                  <Label data='HeaderDecision' />
                </th>
              </>
              :
              <>
                <th scope="col" className="text-start w-5">
                  <Label data='HeaderCorner' />
                </th>
                <th scope="col" className="text-start w-50">
                  <Label data='HeaderName' />
                </th>
                <th scope="col" className="text-center">
                  <Label data='HeaderWinner' />
                </th>
                <th scope="col" className="text-center">
                  <Label data='HeaderResult' />
                </th>
                <th scope="col" className="text-center">
                  <Label data='HeaderDecision' />
                </th>
              </>
            }
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {breakPoint === "sm" || breakPoint === "xs"
                ? <div>{homeCardSmall}</div>
                : <div>{homeCardBig}</div>
              }
            </td>
            <td>
              <div className='score-horizontal-team score-horizontal-team-home'>
                <div className='score-horizontal-noc-flag-name'>
                  {breakPoint === "sm" || breakPoint === "xs"
                    ?
                    <>
                      <div className="score-horizontal-noc-flag">
                        <Flag noc={homeNoc} className='score-horizontal-flag-home' />&ensp;
                        <div className='score-horizontal-name score-horizontal-name-home d-block d-md-none'><strong>{home?.participant?.shortName}</strong></div>
                      </div>
                    </>
                    :
                    <>
                      <div className="score-horizontal-noc-flag">
                        <Flag noc={homeNoc} className='score-horizontal-flag-home' />&nbsp;
                        <div className='score-horizontal-name score-horizontal-name-home'><strong>{home?.participant?.name}</strong></div>
                      </div>
                    </>
                  }
                </div>
              </div>
            </td>
            <td>
            {breakPoint === "sm" || breakPoint === "xs"
              ? <>
                  <div className="d-flex align-items-center justify-content-center">
                    <strong>{officialHomeCheck}</strong>
                  </div>
              </>
              : <>
                  <div className="d-flex align-items-center score-horizontal-result-number">
                    <strong>{officialHomeCheck}</strong>
                  </div>
              </>
            }
            </td>
            <td className="text-end align-middle" >
              <div className='score-horizontal-result-number'>
                {(officialCodeHome === 'RM' || officialCodeHome === 'RM_POINTS') && officialHomeW !== 'BDSQ'
                  ? <>{officialHomeW}</>
                  : officialCodeHome === 'POINTS'
                    ? <>{officialHomeW}</>
                    : losers === 'BDSQ'
                      ? officialHomeW
                      : ''
                }
              </div>
            </td>
            <td className="text-center align-middle" >
              <div className='score-horizontal-result-number'>
                {(officialCodeHome === 'RM' || officialCodeHome === 'RM_POINTS') && officialHomeW !== 'BDSQ'
                  ? <>{round} {timer}</>
                  : officialCodeHome === 'POINTS'
                    ? <>{homeResult}:{awayResult}</>
                    : ''
                }
              </div>
            </td>
          </tr>
          


          <tr>
            <td>
              {breakPoint === "sm" || breakPoint === "xs"
                ? <div>{awayCardSmall}</div>
                : <div>{awayCardBig}</div>
              }
            </td>
            <td>
              <div className='score-horizontal-team score-horizontal-team-away'>
                <div className='score-horizontal-noc-flag-name'>
                  {breakPoint === "sm" || breakPoint === "xs"
                    ?
                    <>
                      <div className="score-horizontal-noc-flag">
                        <Flag noc={awayNoc} className='score-horizontal-flag-away' />&ensp;
                        <div className='score-horizontal-name score-horizontal-name-away d-block d-md-none'><strong>{away?.participant?.shortName}</strong></div>
                      </div>
                    </>
                    :
                    <>
                      <div className="score-horizontal-noc-flag">
                        <Flag noc={awayNoc} className='score-horizontal-flag-away' />&ensp;
                        <div className='score-horizontal-name score-horizontal-name-away'><strong>{away?.participant?.name}</strong></div>
                      </div>
                    </>
                  }
                </div>
              </div>
            </td>
            <td>
            {breakPoint === "sm" || breakPoint === "xs"
              ? <>
                  <div className="d-flex align-items-center justify-content-center">
                    <strong>{officialAwayCheck}</strong>
                  </div>
              </>
              : <>
                  <div className="d-flex align-items-center score-horizontal-result-number">
                    <strong>{officialAwayCheck}</strong>
                  </div>
              </>
            }
            </td>
            <td className="text-center align-middle" >
              <div className='score-horizontal-result-number'>
                {(officialCodeAway === 'RM' || officialCodeAway === 'RM_POINTS') && officialAwayW !== 'BDSQ'
                  ? <>{officialAwayW}</>
                  : officialCodeAway === 'POINTS'
                    ? <>{officialAwayW}</>
                    : losers === 'BDSQ'
                      ? officialAwayW
                      : ''
                }
              </div>
            </td>
            <td className="text-center align-middle" >
              <div className='score-horizontal-result-number'>
                {(officialCodeAway === 'RM' || officialCodeAway === 'RM_POINTS') && officialAwayW !== 'BDSQ'
                  ? <>{round} {timer}</>
                  : officialCodeAway === 'POINTS'
                    ? <>{homeResult}:{awayResult}</>
                    : ''
                }
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )

  return scoreboard
}

export default KikScoreboard